import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

// Shared loading indicator. Uses the BugZero styleguide spinning circle
// (Reactstrap Spinner, tinted navy via bz-overrides) instead of the old animated
// GIF. Pass `text` to show a contextual message beneath the spinner
// (e.g. "Loading projects...") — matching the Plan projects loader.
const Loader = ({ text }) => (
  <div
    data-testid="loader"
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      padding: '48px 0'
    }}
  >
    <Spinner color="primary" />
    {text && (
      <p className="mb-0" style={{ color: 'var(--ink-muted, #6b7280)', fontSize: '0.875rem' }}>
        {text}
      </p>
    )}
  </div>
);

Loader.propTypes = {
  text: PropTypes.string
};

export default Loader;
